
import _template from "lodash/template"
import _flow from "lodash/flow"
import schedule_template from "./schedule.html._tpl"
import schedule_mobile_template from "./schedule_mobile.html._tpl"
import NumbersFormatter from "app/numbers/formatter/index"


import I18n from "plugins/i18n-js"
import { Page } from "app/multi_device"


interface MonthScheduleEntry {
  month:          number,
  pmt_value:      number
  interest:       number
  principle:      number
  loan_balance:   number
  total_interest: number
}
interface YearScheduleEntry {
  year: number

  ytd_interest: number
  ytd_pmt_value: number
  ytd_principle: number
  loan_balance: number
  total_interest: number

  monthly_schedule: MonthScheduleEntry[]
}


interface OutputMonthScheduleEntry {
  month:       number

  pmt_value:    string | undefined
  principle:    string | undefined
  interest:     string | undefined
  loan_balance: string | undefined
}
interface OutputYearScheduleEntry {
  year: string

  ytd_pmt_value: string | undefined
  ytd_principle: string | undefined
  ytd_interest:  string | undefined
  loan_balance:  string | undefined

  monthly_schedule: OutputMonthScheduleEntry[]
}



const SCHEDULE_MOBILE_TPL = _template(schedule_mobile_template)
const SCHEDULE_TPL = _template(schedule_template)

const LABELS = {
  breakdown:          I18n.t("concepts.real_estate.mortgages.calculator.schedule.labels.breakdown"),
  total_installment:  I18n.t("concepts.real_estate.mortgages.calculator.schedule.labels.total_installment"),
  total_principle:    I18n.t("concepts.real_estate.mortgages.calculator.schedule.labels.total_principle"),
  total_interest:     I18n.t("concepts.real_estate.mortgages.calculator.schedule.labels.total_interest"),
  outstanding:        I18n.t("concepts.real_estate.mortgages.calculator.schedule.labels.outstanding"),
}


const process_data = (schedule: YearScheduleEntry[]): OutputYearScheduleEntry[] => {
  const view_obj = [] as Array<{
    year: string

    ytd_pmt_value: string | undefined
    ytd_principle: string | undefined
    ytd_interest:  string | undefined
    loan_balance:  string | undefined

    monthly_schedule: Array<{
      month:       number

      pmt_value:    string | undefined
      principle:    string | undefined
      interest:     string | undefined
      loan_balance: string | undefined
    }>
  }>
  schedule.forEach((year) => {
    const monthly_schedule = [] as OutputMonthScheduleEntry[]
    year.monthly_schedule.forEach((interval) => {
      if(Page.isForMobile()){
        monthly_schedule.push({
          month:        interval.month,
          pmt_value:    NumbersFormatter.numberWithCommas(interval.pmt_value.toFixed(0)),
          principle:    NumbersFormatter.numberWithCommas(interval.principle.toFixed(0)),
          interest:     NumbersFormatter.numberWithCommas(interval.interest.toFixed(0)),
          loan_balance: NumbersFormatter.numberWithCommas(interval.loan_balance.toFixed(0)),
        })
      }
      else {
        monthly_schedule.push({
          month:        interval.month,
          pmt_value:    NumbersFormatter.numberWithCommasAndCurrency(interval.pmt_value.toFixed(2)),
          principle:    NumbersFormatter.numberWithCommasAndCurrency(interval.principle.toFixed(2)),
          interest:     NumbersFormatter.numberWithCommasAndCurrency(interval.interest.toFixed(2)),
          loan_balance: NumbersFormatter.numberWithCommasAndCurrency(interval.loan_balance.toFixed(2)),
        })
      }
    })
    if(Page.isForMobile()) {
      view_obj.push({
        year:           I18n.t("concepts.real_estate.mortgages.calculator.schedule.labels.year", {year: year.year}),
        ytd_pmt_value:  NumbersFormatter.numberWithCommas(year.ytd_pmt_value.toFixed(0)),
        ytd_principle:  NumbersFormatter.numberWithCommas(year.ytd_principle.toFixed(0)),
        ytd_interest:   NumbersFormatter.numberWithCommas(year.ytd_interest.toFixed(0)),
        loan_balance:   NumbersFormatter.numberWithCommas(year.loan_balance.toFixed(0)),

        monthly_schedule: monthly_schedule,
      })
    }
    else {
      view_obj.push({
        year:           I18n.t("concepts.real_estate.mortgages.calculator.schedule.labels.year", {year: year.year}),
        ytd_pmt_value:  NumbersFormatter.numberWithCommasAndCurrency(year.ytd_pmt_value.toFixed(2)),
        ytd_principle:  NumbersFormatter.numberWithCommasAndCurrency(year.ytd_principle.toFixed(2)),
        ytd_interest:   NumbersFormatter.numberWithCommasAndCurrency(year.ytd_interest.toFixed(2)),
        loan_balance:   NumbersFormatter.numberWithCommasAndCurrency(year.loan_balance.toFixed(2)),

        monthly_schedule: monthly_schedule,
      })
    }
  })
  return view_obj
}

const to_html = (datum: unknown) => {
  return Page.isForMobile() ? SCHEDULE_MOBILE_TPL({schedule: datum, labels: LABELS}) : SCHEDULE_TPL({schedule: datum, labels: LABELS})
}

const render = _flow(process_data, to_html)


export default {
  render,
}
